import { d as v } from "./define-element-Dl91r6Vu.js";
import "./sp-overlay-C7imRS_0.js";
import { i as m, x as a } from "./lit-element-6iugfgmM.js";
import { S as y } from "./Base-pdJ5fkYW.js";
import { n as i } from "./property-BWlAHqg_.js";
import { t as c } from "./state-STZTbIJp.js";
import { i as p } from "./query-D8_rwLua.js";
const u = m`
    slot[name=longpress-describedby-descriptor]{display:none}
`;
var C = Object.defineProperty, n = (g, e, t, o) => {
  for (var h, s = void 0, l = g.length - 1; l >= 0; l--) (h = g[l]) && (s = h(e, t, s) || s);
  return s && C(e, t, s), s;
};
class r extends y {
  constructor() {
    super(...arguments), this.offset = 6, this.disabled = !1, this.receivesFocus = "auto", this.clickContent = [], this.longpressContent = [], this.hoverContent = [], this.targetContent = [];
  }
  static get styles() {
    return [u];
  }
  getAssignedElementsFromSlot(e) {
    return e.assignedElements({ flatten: !0 });
  }
  handleTriggerContent(e) {
    this.targetContent = this.getAssignedElementsFromSlot(e.target);
  }
  handleSlotContent(e) {
    switch (e.target.name) {
      case "click-content":
        this.clickContent = this.getAssignedElementsFromSlot(e.target);
        break;
      case "longpress-content":
        this.longpressContent = this.getAssignedElementsFromSlot(e.target);
        break;
      case "hover-content":
        this.hoverContent = this.getAssignedElementsFromSlot(e.target);
    }
  }
  handleBeforetoggle(e) {
    const { target: t } = e;
    let o;
    if (t === this.clickOverlayElement) o = "click";
    else if (t === this.longpressOverlayElement) o = "longpress";
    else {
      if (t !== this.hoverOverlayElement) return;
      o = "hover";
    }
    e.newState === "open" ? this.open = o : this.open === o && (this.open = void 0);
  }
  update(e) {
    var t, o, h, s, l, d;
    e.has("clickContent") && (this.clickPlacement = ((t = this.clickContent[0]) == null ? void 0 : t.getAttribute("placement")) || ((o = this.clickContent[0]) == null ? void 0 : o.getAttribute("direction")) || void 0), e.has("hoverContent") && (this.hoverPlacement = ((h = this.hoverContent[0]) == null ? void 0 : h.getAttribute("placement")) || ((s = this.hoverContent[0]) == null ? void 0 : s.getAttribute("direction")) || void 0), e.has("longpressContent") && (this.longpressPlacement = ((l = this.longpressContent[0]) == null ? void 0 : l.getAttribute("placement")) || ((d = this.longpressContent[0]) == null ? void 0 : d.getAttribute("direction")) || void 0), super.update(e);
  }
  renderSlot(e) {
    return a`
            <slot name=${e} @slotchange=${this.handleSlotContent}></slot>
        `;
  }
  renderClickOverlay() {
    var e;
    const t = this.renderSlot("click-content"), o = a`
            <sp-overlay
                id="click-overlay"
                ?disabled=${this.disabled || !this.clickContent.length}
                ?open=${this.open === "click" && !!this.clickContent.length}
                .offset=${this.offset}
                .placement=${this.clickPlacement || this.placement}
                .triggerElement=${this.targetContent[0]}
                .triggerInteraction=${"click"}
                .type=${this.type !== "modal" ? "auto" : "modal"}
                @beforetoggle=${this.handleBeforetoggle}
                .receivesFocus=${this.receivesFocus}
            >
                ${t}
            </sp-overlay>
        `;
    return (e = this.triggeredBy) != null && e.includes("click") || this.clickContent.length ? o : t;
  }
  renderHoverOverlay() {
    var e;
    const t = this.renderSlot("hover-content"), o = a`
            <sp-overlay
                id="hover-overlay"
                ?open=${this.open === "hover" && !!this.hoverContent.length}
                ?disabled=${this.disabled || !this.hoverContent.length || !!this.open && this.open !== "hover"}
                .offset=${this.offset}
                .placement=${this.hoverPlacement || this.placement}
                .triggerElement=${this.targetContent[0]}
                .triggerInteraction=${"hover"}
                .type=${"hint"}
                @beforetoggle=${this.handleBeforetoggle}
                .receivesFocus=${this.receivesFocus}
            >
                ${t}
            </sp-overlay>
        `;
    return (e = this.triggeredBy) != null && e.includes("hover") || this.hoverContent.length ? o : t;
  }
  renderLongpressOverlay() {
    var e;
    const t = this.renderSlot("longpress-content"), o = a`
            <sp-overlay
                id="longpress-overlay"
                ?disabled=${this.disabled || !this.longpressContent.length}
                ?open=${this.open === "longpress" && !!this.longpressContent.length}
                .offset=${this.offset}
                .placement=${this.longpressPlacement || this.placement}
                .triggerElement=${this.targetContent[0]}
                .triggerInteraction=${"longpress"}
                .type=${"auto"}
                @beforetoggle=${this.handleBeforetoggle}
                .receivesFocus=${this.receivesFocus}
            >
                ${t}
            </sp-overlay>
            <slot name="longpress-describedby-descriptor"></slot>
        `;
    return (e = this.triggeredBy) != null && e.includes("longpress") || this.longpressContent.length ? o : t;
  }
  render() {
    return a`
            <slot
                id="trigger"
                name="trigger"
                @slotchange=${this.handleTriggerContent}
            ></slot>
            ${[this.renderClickOverlay(), this.renderHoverOverlay(), this.renderLongpressOverlay()]}
        `;
  }
  updated(e) {
    super.updated(e), this.disabled && e.has("disabled") && (this.open = void 0);
  }
  async getUpdateComplete() {
    return await super.getUpdateComplete();
  }
}
n([i({ attribute: "triggered-by" })], r.prototype, "triggeredBy"), n([i({ reflect: !0 })], r.prototype, "placement"), n([i()], r.prototype, "type"), n([i({ type: Number })], r.prototype, "offset"), n([i({ reflect: !0 })], r.prototype, "open"), n([i({ type: Boolean, reflect: !0 })], r.prototype, "disabled"), n([i({ attribute: "receives-focus" })], r.prototype, "receivesFocus"), n([c()], r.prototype, "clickContent"), n([c()], r.prototype, "longpressContent"), n([c()], r.prototype, "hoverContent"), n([c()], r.prototype, "targetContent"), n([p("#click-overlay", !0)], r.prototype, "clickOverlayElement"), n([p("#longpress-overlay", !0)], r.prototype, "longpressOverlayElement"), n([p("#hover-overlay", !0)], r.prototype, "hoverOverlayElement"), v("overlay-trigger", r);
//# sourceMappingURL=overlay-trigger-25h1jNVy.js.map
